/* eslint-disable arrow-body-style */
import React from 'react';
import { IRangeSelectorProps, TRadioListItem } from './_type';
import CustomRange from './components/CustomRange';
import {
  Button,
  Dropdown,
  Radio
} from 'tea-component';
import CommonBubble from '@home/components/CommonBubble';
import useFilterData from './hooks/useFilterData';
import useFilterLocale from './hooks/useLocale';
import { LOCALE_CN } from './config';
import './index.scss';
import FilterInputText from './components/FilterInputText';
import { useIntl } from 'umi';
import FilterSelectButton from './components/FilterSelectButton';
import classNames from 'classnames';

const RadioGroup = Radio.Group;

// 组装接口配置和页面配置的相关信息传递给子组件 ，如：nameEn、nameCn、formatter、width、tooltipEn、tooltipCn等
const RangeSelect = (props: IRangeSelectorProps) => {
  const {
    className,
    style,
    boxClassName = '',
    overlayClassName = '',
    boxStyle = {},
    // radioOptions,
    name,
    value: valueProps,
    defaultValue,
    listWidth = 310,
    onChange,
    // customContentRander,
    placeholder,
    locale= LOCALE_CN,
    language,
    allRadioContent,
    radioListContent,
    tooltip,
    customRangeClassName = '',
    customRangeStyle = {},
    customRangeUnitText,
    customRangeLeftPlaceholder,
    customRangeRightPlaceholder,
    customRangeWidth,
    ...restProps
  } = props || {};
  const { formatMessage } = useFilterLocale(locale, language);
  const { formatMessage: umiFormatMessage } = useIntl(); // 中英切换方法
  const {
    value,
    isOpen,
    radioValue,
    errorMsg,
    selectedRadio,
    handleOpen,
    handleClose,
    handleConfirm,
    handleChange,
    handleValueChange,
    // handleRadioChange,
  } = useFilterData(props);

  const renderRadio = (item: TRadioListItem) => {
    const isSelected = radioValue === item?.value;
    const isCustom = item?.type === 'customInput';
    if (isSelected) {
      if (isCustom) {
        return <>
          <Radio name={item?.value}>{item?.text}</Radio>
          <CustomRange
            className={customRangeClassName}
            style={customRangeStyle}
            value={{
              max: value?.inputValue?.max,
              min: value?.inputValue?.min,
            }}
            selectedRadio={selectedRadio} 
            onChange={handleValueChange}
            locale={locale}
            language={language}
            unitText={customRangeUnitText}
            leftPlaceholder={customRangeLeftPlaceholder}
            rightPlaceholder={customRangeRightPlaceholder}
            width={customRangeWidth}
          />
        </>;
      } 
      return <>
        <Radio name={item?.value}> <FilterInputText selectedRadio={selectedRadio} onChange={handleValueChange} value={value?.inputValue?.max}/> </Radio>
      </>;
    } 
    return<Radio name={item?.value}>{item?.text}</Radio>;
  };
  return <CommonBubble
    dark
    escapeWithReference
    flipped={false}
    content={tooltip ? tooltip : null}
  >
    <Dropdown
      className={`db-filter-select dbb-range-filter ${className}`}
      boxClassName={`dbb-range-filter-box ${boxClassName}`}
      overlayClassName={`dbb-range-filter-overlay ${overlayClassName}`}
      boxStyle={listWidth ? { ...boxStyle, width: `${listWidth}px` } : { ...boxStyle }}
      style={style}
      updateOnChildrenChange={true}
      appearance="button"
      open={isOpen}
      button={<FilterSelectButton
        name={name}
        formatMessage={formatMessage}
        value={value}
        selectedRadio={radioValue === (allRadioContent?.value ||'all') ? allRadioContent : selectedRadio}
      />}
      positionFixed={false}
      onOpen={handleOpen}
      onClose={handleClose}
      clickClose={false}
      {...restProps}
    >
      <div className="db-filter-select-content">
        {/* {customContentRander && customContentRander({ value, radioValue, selectedRadio, handleChange })} */}
        <RadioGroup
          value={radioValue}
          onChange={handleChange}
        >
          {
            allRadioContent?.text ? (
              <div className={classNames("dbb-range-filter-all", 
                {"dbb-range-filter-all-next-selected": radioValue === radioListContent?.[0]?.value})}>
                <Radio name={allRadioContent?.value}>{allRadioContent?.text}</Radio>
              </div>
            ) : null
          }
          {
            radioListContent?.map((item, index)=>{
              return (
                <div className={classNames("dbb-range-filter-item", 
                  {"dbb-range-filter-item-custom": item?.type === 'customInput'},
                  {"dbb-range-filter-item-selected": radioValue !== (allRadioContent?.value ||'all') && radioValue !== 'custom'})
                } key={item?.value + index}>
                  {
                    renderRadio(item)
                  }
                  
                </div>
              );
            })
          }
        </RadioGroup>
      </div>
      {errorMsg? (
        <div className="dbb-range-filter-error">
          {formatMessage({ id: errorMsg }) || umiFormatMessage({ id: errorMsg }) }
        </div>
      ) : null}
      
      <div className="dbb-bottom-btn">
        <Button
          type="primary"
          className="dbb-bottom-btn-left"
          onClick={handleConfirm}
          // disabled={isMinError || isMaxError}
          disabled={!!value?.inputValue?.errorMsg}
        >
          {formatMessage({ id: 'dbb_confirm'})}
        </Button>
        <Button
          className="dbb-bottom-btn-right"
          onClick={handleClose}
        >
          {formatMessage({ id: 'dbb_cancel' })}
        </Button>
      </div>
        
    </Dropdown>
  </CommonBubble>;
};

export default RangeSelect;
